<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
        <kt-row id="psp_request_details">
            <kt-col xs="12" md="6">
                <psp-request-info v-if="status !== 'loading'" :psp_request="form_data"></psp-request-info>
            </kt-col>
            <kt-col xs="12" md="6">
                <psp-request-setting v-if="status !== 'loading'" :psp_request="form_data"></psp-request-setting>
            </kt-col>
        </kt-row>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import mainContent from '@/components/main-content'
import {
    pspRequestInfo,
    pspRequestSetting,
}  from './components'
export default {
    components: {
        mainContent,
        'psp-request-info': pspRequestInfo,
        'psp-request-setting': pspRequestSetting
    },
    computed: {
        ...mapGetters('pspRequest', [
            'form_data', 'status'
        ]),
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('pspRequest/find', vm.$route.params.hashid)
        })
    }
}
</script>

<style>
@media (min-width: 768px) {
    #psp_request_details> :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>